import React from 'react';
import styles from './styles.module.scss';

const ButtonSelectRow = ({action, icon}) => {
  const handleClick = () => action();

  return (
    <label className={styles.inputContainer}>
      <div className={styles.checkboxContainer} onClick={handleClick}>
        <img src={icon} className={styles.checkbox} alt={'click me'}/>
      </div>
    </label>
  );
};

export default ButtonSelectRow;
